<!--
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2022-07-30 17:36:38
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-01-15 16:55:04
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/picc2212/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="tail">
    <div id="banner">
      <div class="buttonGroup">
        <div @click="showPrize" class="button1">我的奖品</div>
        <div @click="showRule" class="button1">活动说明</div>
      </div>
    </div>
    <div class="mastryboxFluid">
      <div class="mastrybox clear">
        <img
          @click="lotteryFn"
          class="gift"
          v-for="(item, index) in gifts"
          :key="index"
          src="https://source.qunarzz.com/site/images/wns/20230103-shijianchen-2.png"
          alt=""
        />
      </div>
      <p class="times">剩余抽奖机会：{{ setting.zs }}次</p>
      <div @click="getMoreTimes" class="getMore"></div>
    </div>
    <a v-maidian="'home'" href="https://mp.weixin.qq.com/s/mJzT4GX398EWOTnj2CJi1g"
      ><img
        src="https://source.qunarzz.com/site/images/wns/20230109-shijianchen-img.png"
        class="box"
        alt=""
    /></a>
    <img
      src="https://source.qunarzz.com/site/images/wns/20230103-shijianchen-4.png"
      class="tit"
      alt=""
    />
    <videoComp
      src="https://source.qunarzz.com/site/images/wns/20220103-shijianchen-video.mp4"
      poster="https://source.qunarzz.com/site/images/wns/20220103-shijianchen-poster.png"
    />
    <img
      src="https://source.qunarzz.com/site/images/wns/20230103-shijianchen-6.png"
      class="tit"
      alt=""
    />
    <div class="card2">
      <p class="daojishi">
        春节购票倒计时<span class="days">{{ days }}</span
        >天
      </p>
      <div @click="jumpTrain" class="getMore"></div>
    </div>
    <line-comp></line-comp>
    <!-- <div v-if="type=='fromtrain' && task==0" class="bottom">任务1：浏览页面{{seconds}}s</div>
    <div v-if="type=='fromtrain' && task==1" @click="share" class="bottom">任务2：分享活动<span class="shareBtn">（点击按钮可一键分享）</span></div>
    <div v-if="type=='fromtrain' && task==2" @click="jumpTo" class="bottom">已完成任务，继续购买车票</div> -->
    <!-- <div class="tab">
      <img
        class="tit"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-1.png"
        alt=""
      />
    </div>
    <div class="box">
      <div class="daojishi">
        <span class="days">{{ days }}</span>
      </div>
      <div class="both">
        <img
          @click="jumpFlight"
          v-maidian="'jumpFlight'"
          class="flight"
          src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-flight.png"
          alt=""
        />
        <img
          @click="jumpTrain"
          v-maidian="'jumpTrain'"
          class="flight"
          src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-train.png"
          alt=""
        />
      </div>
    </div>
    <img
      class="tit"
      src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-2.png"
      alt=""
    />
    <div class="swipe-wrapper">
      <mt-swipe :auto="0" ref="swipeWrapper">
        <mt-swipe-item v-for="(item, index) in imgList" :key="index">
          <div class="img-box">
            <div class="img">
              <img @click="jumpTo(index)" :src="item" alt="" />
            </div>
          </div>
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <img
      src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-6.png"
      class="tit tit2"
      alt=""
    />
    <div class="mastrybox clear">
      <img
        @click="lotteryFn"
        class="gift"
        v-for="(item, index) in gifts"
        :key="index"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-gift.png"
        alt=""
      />
    </div>
    <div class="submit">
      <p class="times">剩余抽奖机会：{{ setting.zs }}次</p>
      <img
        @click="getMoreTimes"
        src="https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-5.png"
        class="getMore"
        alt=""
      />
      <a href="https://www.picc.com/" v-maidian="'gohome'" class="knowMore"
        >前往官网·了解更多</a
      >
    </div> -->
  </div>
</template>
<script>
import banner from './components/banner.vue';
import lineComp from './components/line.vue';
import loginDialog from './components/dialog/login/index';
import giftDialog from './components/dialog/gift/index';
import videoComp from './components/videoComp.vue';
import moreTimes from './components/dialog/moreTimes/index';
import moment from 'moment';
import ruleDialog from './components/dialog/rule/index';
import showVideo from './components/dialog/showVideo/index';
import { commonShare } from '@/utils/hybird'
export default {
  components: {
    banner,
    lineComp,
    videoComp,
  },
  data() {
    return {
      gifts: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      setting: {},
      days: 0,
      seconds:30,
      task:0,
      type:'',
      jumpUrl:'',
      linkList: [
        'https://m.picc.com/wproduct/#/entryroute?productCode=EAK_0017',
        'https://mlife.picc.com/ebsweb/#/newfs_fusion?combCode=C71940&utmSource=234&utmType=1&platform=f&dataSource=SEM-WAP&JobNo=6111100001&eventsName=wap',
        'https://szgezhangtest.picchealth.com/mall/#/lifeSerious?source=2',
      ],
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-31.png',
        'https://source.qunarzz.com/site/images/wns/20221226-shijianchen-picc-32.png',
        'https://source.qunarzz.com/site/images/wns/20221228-shijianchen-thumb.jpeg',
      ],
    };
  },
  mounted() {
    // moreTimes({});
    this.getChannelNum();
    let days = -moment().diff('2023/01/21', 'days');
    this.days = days;
    if(this.$route.query.bd_source == 'train'){
      this.type = 'fromtrain'
      let seconds = 30;
      this.jumpUrl = decodeURIComponent(this.$route.query.jumpurl);
      let timer = setInterval(()=>{
        seconds--;
        this.seconds = seconds;
        if(seconds == 0){
          clearTimeout(timer);
          timer = null;
          this.task = 1;
        }
      },1000)
    }
    // loginDialog({

    // })
    // giftDialog({
    //     giftType:'THANKS',
    //     getMoreTimes:this.getMoreTimes,
    // })
  },
  methods: {
    jumpTo() {
      window.location.href = this.jumpUrl;
    },
    share(){
      this.task = 2;
      commonShare();
    },
    showRule: ruleDialog,
    getMoreTimes() {
      this.getChannelNum(() => {
        moreTimes({
          setting: this.setting,
          callback: this.addTimeBySource,
        });
      });
    },
    addTimeBySource(source, callback) {
      this.commonAjax({
        url: '/commonly/addTimeBySource?source=' + source,
        method: 'get',
        hideError: true,
        success: (data) => {
          this.getChannelNum(callback);
        },
      });
    },
    jumpTrain() {
      if (hysdk.sniff.scheme) {
        location.href = hysdk.sniff.scheme + `://railway/main`;
      } else {
        location.href =
          'https://touch.train.qunar.com/train_touch/index.html#/?&bd_source=jinjiangjituan';
      }
    },
    commonAjax(config) {
      this.$axios[config.method || 'post'](config.url, config.data || {}).then(
        (res) => {
          if (res.code == 200) {
            config.success && config.success(res.data);
          } else if (res.code == 400) {
            if (config.hide == 'login') {
              return;
            }
            loginDialog({
              callback: () => {
                this.commonAjax(config);
              },
            });
          } else {
            !config.hideError &&
              this.$dialog.alert({
                message: res.message,
              });
          }
        },
      );
    },
    lotteryFn() {
      this.getMyPrize((item, hasLottery) => {
        if (hasLottery) {
          giftDialog({
            giftType: item.prizeCode,
            ext: item.extJson,
            getMoreTimes: this.getMoreTimes,
            id: item.id,
          });
          return;
        }
        this.commonAjax({
          url: '/commonly/v2/lottery',
          method: 'post',
          success: (data) => {
            giftDialog({
              giftType: data.code,
              ext: data.ext,
              getMoreTimes: this.getMoreTimes,
              id: data.winRecordId,
            });
            this.getChannelNum();
          },
        });
      });
    },
    showPrize() {
      this.getMyPrize((item) => {
        giftDialog({
          giftType: item.prizeCode,
          ext: item.extJson,
          getMoreTimes: this.getMoreTimes,
          id: item.id,
        });
      });
    },
    getMyPrize(callback) {
      this.$http({
        url: '/commonly/getMyPrzie',
        type: 'get',
        login: loginDialog,
        success: (res) => {
          let result = [];
          res.data.forEach((item) => {
            if (item.prizeCode != 'THANKS') {
              result.push(item);
            }
          });
          let item = result[0];
          callback && callback(item, result.length > 0);
          this.hasLottery = result.length > 0;
        },
      });
    },
    getChannelNum(callback) {
      this.commonAjax({
        url: '/commonly/getChannelNum',
        method: 'get',
        hide: callback ? null : 'login',
        success: (data) => {
          this.setting = data;
          callback && callback(data);
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
#tail {
  background: #f6372a
    url(https://source.qunarzz.com/site/images/wns/20230104-shijianchen-bg.jpg)
    no-repeat;
  background-size: 100% auto;
  min-height: 1987px;
}
.buttonGroup {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 30px);
  margin: 0 auto;
  position: absolute;
  bottom: 20px;
  left: 15px;
}
#banner {
  height: 279px;
  position: relative;
  .rule {
    position: absolute;
    right: 10px;
    bottom: 5px;
    width: 62px;
  }
  .button1 {
    color: #f9e586;
    text-decoration: underline;
  }
}
.tit {
  width: calc(100% - 46px);
  margin: 40px auto 27px;
}
.tit2 {
  margin-bottom: 15px;
}
.box {
  width: 359px;
  display: block;
  margin-left: 15px;
  margin-top: 20px;
}
.both {
  display: flex;
  padding: 10px;
  margin-top: 10px;
  background: #fff4ec;
  border-radius: 6px;
  justify-content: space-between;
}
.flight {
  width: 163px;
}
.card2 {
  background: url(https://source.qunarzz.com/site/images/wns/20230103-shijianchen-04.png)
    no-repeat;
  background-size: 100% auto;
  width: calc(100% - 30px);
  height: 221px;
  margin: 0 auto;
  position: relative;
}
.daojishi {
  width: 8rem;
  position: relative;
  height: 50px;
  margin: 0 auto;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  .days {
    font-size: 24px;
    font-family: NotoSansHans;
    font-weight: bold;
    margin-left: 8px;
    margin-right: 8px;
    line-height: 16px;
  }
}
.swipe-wrapper {
  width: 355px;
  height: 240px;
  margin: 0 auto;
  /deep/ .mint-swipe-indicator {
    opacity: 1;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #ffc168;
    &.is-active {
      width: 46px;
      height: 5px;
      background: #ffc168;
      border-radius: 2px;
    }
  }
}
.img {
  height: 204px;
  overflow-y: hidden;
}
.img img {
  width: 100%;
  height: 204px;
}
.mastryboxFluid {
  width: 355px;
  height: 355px;
  margin: 0 auto;
  padding: 53px 40px;
  position: relative;
  box-sizing: border-box;
}
.gift {
  width: 57px;
  height: 64px;
  float: left;
  margin-right: 45px;
  margin-bottom: 15px;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
}
.getMore {
  height: 45px;
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  left: 0;
}
.times {
  font-family: FZMoDengTiS;
  font-weight: 600;
  color: #f9e586;
  font-size: 9px;
}
.bottom{
  background:url(https://source.qunarzz.com/site/images/wns/20230104-shijianchen-tail-1.png) no-repeat;
  background-size: 100% 100%;
  width:100%;
  height:41px;
  display: flex;
  align-items: center;
  position: fixed;
  left:0;
  bottom: 0;
  color:#fff;
  z-index: 10;
  justify-content: center;
}
.knowMore {
  font-size: 16px;
  font-family: FZMoDengTiS;
  font-weight: 600;
  color: #f2d2a0;
  display: block;
  text-decoration: underline;
  padding-bottom: 15px;
}
.shareBtn{
  font-size: 10px;
  opacity: 0.8;
}
</style>